import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white p-25" }
const _hoisted_2 = { style: {"margin":"-24px 0 -24px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4\"><div class=\"d-flex align-items-center\" style=\"gap:15px;\"><div><span class=\"d-block\" style=\"margin-bottom:5px;\">Trading Volume</span><h3 class=\"mb-0 fs-20 lh-1\">$117,950</h3></div><div><span class=\"d-inline-block bg-success-80 border-success-60 border px-2 rounded-pill text-success-60 fs-12 fw-medium\"> +7.6% </span></div></div><span>Last 7 days</span></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "bar",
            height: "200",
            options: _ctx.tradingVolume,
            series: _ctx.trading
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}